{
    "NAME": "ApparaatlijstTaal",
    "DeviceList_Column_DeviceNumber": "Apparaat",
    "DeviceList_Column_DeviceNumberInternal": "Verlenging",
    "DeviceList_Column_Description": "Beschrijving",
    "DeviceList_Column_Partition": "Partitie",
    "DeviceList_Column_DeviceType": "Apparaattype",
    "DeviceList_Column_IDOnTelSys": "Resource Account",
    "DeviceList_Column_QueueStatus": "Wachtrijstatus",
    "DeviceList_Column_Users": "Gebruikers",
    "DeviceList_Filter_DeviceType": "Apparaattype",
    "DeviceList_Filter_Partition": "Partitie",
    "DeviceList_Add_Disabled_SelectTelephonyServer": "Selecteer een telefonieserver om een ​​apparaat toe te voegen.",
    "DeviceList_Users_MoreUsers": "[{} meer gebruikers]",
    "DeviceList_Value_None": "Geen",
    "DeviceList_Value_All": "Alle"
}